import { IconButton } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import * as OpenBackInStockNotificationDialog from '@ori-events/open-back-in-stock-notification-dialog';
import { NotificationFilled, Notification } from '@ori-ui/icons';
import { useCallback } from 'react';
import { NOTIFICATION, NOTIFICATION_FILLED, NOTIFY_ME } from "../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var NotifyMe = function NotifyMe(_ref) {
  var code = _ref.code,
    onNotifyMeButtonClick = _ref.onNotifyMeButtonClick;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var onClickHandler = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (onNotifyMeButtonClick) {
      onNotifyMeButtonClick();
    } else {
      window.dispatchEvent(new CustomEvent(OpenBackInStockNotificationDialog.Name, {
        detail: {
          code: code
        }
      }));
    }
  }, [code, onNotifyMeButtonClick]);
  return /*#__PURE__*/_jsx(IconButton, {
    smallerOnMobile: true,
    hoverIcon: /*#__PURE__*/_jsx(NotificationFilled, {
      "data-testid": getTestId(NOTIFICATION_FILLED),
      fontSize: "inherit"
    }),
    testId: "".concat(getTestId(NOTIFY_ME), "-").concat(code),
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(Notification, {
      "data-testid": getTestId(NOTIFICATION),
      fontSize: "inherit"
    })
  });
};
//# sourceMappingURL=NotifyMe.js.map